import "./../areaChart.css";

import React, { useEffect } from "react";
import * as d3 from "d3";

interface AreaChartGraphProps {
    height: number;
    width: number;
    margin: number;
    xScale: d3.ScaleLinear<number, number> | d3.ScaleTime<number, number>;
    yScale: d3.ScaleLinear<number, number>;
    tickValues: number[];
    mobile: boolean;
    yMax: number;
    d3Id: string;
}

export const AreaChartGraph = (props: AreaChartGraphProps) => {
    const {
        height,
        width,
        margin,
        xScale,
        yScale,
        tickValues,
        mobile,
        yMax,
        d3Id,
    } = props;

    useEffect(() => {
        //creating vertical lines on the grid
        d3.select(`#${d3Id}`)
            .selectAll(".x-axis")
            .append("g")
            .attr("class", mobile ? "mobile-grid" : "grid")
            .attr("transform", "translate(0, 0)")
            .call(
                d3
                    .axisBottom(xScale)
                    .tickSize(-height + margin * 2)
                    .tickValues(tickValues)
                    .tickFormat(d => "")
            );

        //creating horizontal lines on the grid
        d3.select(`#${d3Id}`)
            .selectAll(".y-axis")
            .append("g")
            .attr("class", mobile ? "mobile-grid" : "grid")
            .call(
                d3
                    .axisLeft(yScale)
                    .tickSize(-width + margin * 2)
                    .tickFormat(() => "")
                    .tickValues(mobile ? [0, yMax] : null)
            );

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <g
            className="graph-container"
            transform={`translate(0, ${height - margin * 2})`}
        ></g>
    );
};
